// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ad-0";
export var optionCard = "_ad-1";